import { Grid } from "@mui/material";
import { FormattedMessage } from "react-intl";
import useFormatPrice from "hooks/useFormatPrice";
import { CancelFeeCheckResponse } from "services/paymentService";
import CardLayout from "components/layout/CardLayout";

const CancelInfoSummarySection = ({
  cancelFee,
}: {
  cancelFee: CancelFeeCheckResponse;
}) => {
  const formatPrice = useFormatPrice();

  const getHeader = () => {
    return (
      <p className="text-sm font-bold">
        <FormattedMessage id="orders.cancelEstimation" />
      </p>
    );
  };

  const refundFee = cancelFee.cancelFee; // 취소 수수료
  const realPaymentCancelAmount = cancelFee.realPaymentCancelAmount; // 총 환불 가격(수수료 제외)
  const mileageCancelAmount = cancelFee.mileageCancelAmount; // 라차 포인트 사용액

  // 수수료 발생하는 경우 적립금에서 먼저 차감
  // const refundedLachaPoint =
  // usedLachaPoint > refundFee ? usedLachaPoint - refundFee : 0; // 적립금 환불 금액
  // const refundFeeLeft =
  // usedLachaPoint > refundFee ? 0 : refundFee - usedLachaPoint; // 수수료가 사용 적립금보다 많은 경우 현금 환불 금액에서 차감할 금액
  // const refundedPrice = originalPrice - usedLachaPoint - refundFeeLeft; // 현금 환불

  return (
    <CardLayout
      header={getHeader()}
      className="w-full rounded-none border-none p-0 shadow-none"
    >
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={6}>
          <p className="text-sm">
            <FormattedMessage id="orders.cancelAmount" />:
          </p>
        </Grid>
        <Grid item xs={6} sx={{ textAlign: "end" }}>
          <p className="text-sm font-bold">
            {/* 현금 환불 */}
            {formatPrice(realPaymentCancelAmount)}
          </p>
        </Grid>
        <Grid item xs={6}>
          <p className="text-sm">
            <FormattedMessage id="point.refundPoint" />:
          </p>
        </Grid>
        <Grid item xs={6} sx={{ textAlign: "end" }}>
          <p className="text-sm font-bold">
            {/* 라차 포인트 환불 */}
            {formatPrice(mileageCancelAmount)}
          </p>
        </Grid>
        <Grid item xs={6}>
          <p className="text-sm">
            <FormattedMessage id="orders.cancelFee" />:
          </p>
        </Grid>
        <Grid item xs={6} sx={{ textAlign: "end" }}>
          <p className="text-sm font-bold">{formatPrice(refundFee)}</p>
        </Grid>
      </Grid>
    </CardLayout>
  );
};

export default CancelInfoSummarySection;
